var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 32,
    viewBox: "0 0 181 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H9.04751C15.8514 0 21.0743 4.63459 21.0743 12.8733C21.0743 21.1121 15.8514 25.7467 9.04751 25.7467H0V0ZM9.04751 24.0914C14.5652 24.0914 19.0146 20.2668 19.0146 12.8733C19.0146 5.4799 14.564 1.69184 9.04751 1.6553H1.9123V24.0914H9.04751Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7222 15.6321C23.7222 9.01216 28.0985 5.18634 33.5054 5.18634C38.9122 5.18634 43.2886 9.01094 43.2886 15.6321C43.2886 22.2533 38.9122 26.0779 33.5054 26.0779C28.0985 26.0779 23.7222 22.2533 23.7222 15.6321ZM41.3397 15.6321C41.3397 10.0414 37.9195 6.8051 33.5054 6.76856C29.0912 6.73202 25.671 10.0414 25.671 15.6321C25.671 21.2229 29.0912 24.5335 33.5054 24.4969C37.9195 24.4592 41.3397 21.2229 41.3397 15.6321Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9731 15.5956C45.9731 9.45309 49.6138 5.18634 55.7563 5.18634C61.3471 5.18634 64.3995 8.82824 64.8416 13.2412H62.8928C62.6358 9.78439 60.1339 6.76734 55.7576 6.76734C50.9025 6.76734 47.9232 10.4092 47.9232 15.5944C47.9232 21.0743 51.3434 24.4957 55.7576 24.4957C60.1717 24.4957 62.4884 21.1486 62.8928 18.4263H64.8416C64.3264 22.436 61.1632 26.0767 55.7563 26.0767C49.9086 26.0767 45.9731 21.9208 45.9731 15.5944V15.5956Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7189 18.5018C87.7189 23.0256 83.8943 25.7479 79.1854 25.7479H68.6665V0.0012207H78.7445C82.5325 0.0012207 85.8797 2.39221 85.8797 6.58466C85.8797 9.23265 84.1878 11.1815 81.6872 11.9915C85.2183 12.6541 87.7189 14.9342 87.7189 18.5018ZM70.5788 1.65652V11.3301H77.8979C81.429 11.3301 83.82 9.56517 83.82 6.58588C83.82 3.60658 81.5764 1.65652 78.3023 1.65652H70.5788ZM85.6592 18.5018C85.6592 15.0816 82.8638 12.9842 78.6336 12.9842H70.5788V24.0926H78.781C82.7164 24.0926 85.6592 21.7381 85.6592 18.5018Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.491 24.2022V25.7466H108.094C106.218 25.7466 105.078 24.6066 105.078 22.6565V20.3764C104.122 23.9805 100.995 26.1133 97.2435 26.1133C93.3081 26.1133 90.5127 23.8331 90.5127 19.9342C90.5127 16.3301 92.8671 13.8295 97.8318 13.8295H100.48C103.68 13.8295 104.856 12.8733 104.856 11.0706C104.856 8.3861 102.649 6.76734 99.4128 6.76734C95.9548 6.76734 93.5273 8.60656 93.1972 12.0633H91.2849C91.6528 7.64919 94.7429 5.18512 99.414 5.18512C104.085 5.18512 106.807 7.72349 106.807 11.475V22.436C106.807 23.5761 107.286 24.201 108.352 24.201H109.492L109.491 24.2022ZM104.967 13.2046H104.93C104.415 14.6382 102.944 15.4482 100.296 15.4482H97.9049C93.8964 15.4482 92.4981 17.7661 92.4981 19.9354C92.4981 22.2533 94.006 24.4969 97.5005 24.4969C101.179 24.4969 104.967 22.0329 104.967 16.3313V13.2046Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.116 5.51764L116.185 30.9708C115.928 31.5956 115.338 32 114.53 32H108.24V30.4555H114.492L116.772 24.6443L109.195 5.51886H111.218L117.692 22.5481L124.091 5.51886H126.114L126.116 5.51764Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 5.38489C134.799 5.38489 130.204 9.9805 130.204 15.6492C130.204 21.3179 134.799 25.9135 140.468 25.9135C146.137 25.9135 150.732 21.3179 150.732 15.6492C150.732 9.9805 146.137 5.38489 140.468 5.38489ZM146.419 17.0414H142.558C142.173 17.0414 141.86 17.3544 141.86 17.7393V21.6005H139.074V17.7393C139.074 17.3544 138.761 17.0414 138.377 17.0414H134.515V14.2558H138.377C138.761 14.2558 139.074 13.9427 139.074 13.5579V9.6967H141.86V13.5579C141.86 13.9427 142.172 14.2558 142.558 14.2558H146.419V17.0414Z",
    fill: "#00EAFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.377 17.0414H134.515V14.2558C130.893 14.2558 130.632 18.592 130.632 18.592C132.754 25.2607 139.076 25.8185 139.076 25.8185V17.7394C139.076 17.3545 138.763 17.0414 138.378 17.0414H138.377Z",
    fill: "url(#paint0_linear_1187_27269)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.377 14.2558C138.761 14.2558 139.074 13.9428 139.074 13.5579V9.69673H141.86C141.86 6.07432 137.524 5.81366 137.524 5.81366C130.855 7.93546 130.297 14.257 130.297 14.257H138.377V14.2558Z",
    fill: "url(#paint1_linear_1187_27269)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.86 5.4787V9.69673V13.5579C141.86 13.9428 142.172 14.2558 142.558 14.2558H146.419V17.0414C150.042 17.0414 150.302 12.7053 150.302 12.7053C148.18 6.03656 141.859 5.4787 141.859 5.4787H141.86Z",
    fill: "url(#paint2_linear_1187_27269)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M146.419 17.0414H142.558C142.173 17.0414 141.86 17.3545 141.86 17.7394V21.6005H139.074C139.074 25.2229 143.41 25.4836 143.41 25.4836C150.079 23.3618 150.637 17.0402 150.637 17.0402H146.419V17.0414Z",
    fill: "url(#paint3_linear_1187_27269)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1187_27269",
    x1: 134.854,
    y1: 14.2558,
    x2: 134.854,
    y2: 25.8185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00AFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00C8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00E6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1187_27269",
    x1: 141.86,
    y1: 10.0341,
    x2: 130.297,
    y2: 10.0341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00AFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00C8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00E6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1187_27269",
    x1: 146.082,
    y1: 17.0414,
    x2: 146.082,
    y2: 5.4787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00AFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00C8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00E6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1187_27269",
    x1: 139.074,
    y1: 21.2631,
    x2: 150.637,
    y2: 21.2631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00AFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00C8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00E6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EAFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main_logo.895b389139a78f35333e2f6c187ef364.svg";
export { ForwardRef as ReactComponent };